import { render, staticRenderFns } from "./Promotion_edit_pos_free.vue?vue&type=template&id=51050fb4&scoped=true&"
import script from "./Promotion_edit_pos_free.vue?vue&type=script&lang=js&"
export * from "./Promotion_edit_pos_free.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_edit_pos_free.vue?vue&type=style&index=0&id=51050fb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51050fb4",
  null
  
)

export default component.exports